import { IMsalContext } from "@azure/msal-react";
import { Theme } from "klayowebshared";
import React from "react";
import { Organization } from "../data/Organization";
import { CurrentUser } from "../data/users/CurrentUser";
import { EventBus } from "./EventBus";

interface IAppContext {
  user?: CurrentUser;
  organization?: Organization;
  canChangeOrg?: boolean;
  canChangeUser?: boolean;
  devMode?: boolean;
  eventBus?: EventBus;
  isAppContext?: boolean;
  newDesign?: boolean;
  setLoading: (event: string, loading: boolean) => void;
  showNotifications?: (mode: any, show: any) => void;
  msal?: IMsalContext;
  theme?: typeof Theme;
}

export const AppContext = React.createContext<IAppContext>({
  user: {} as CurrentUser,
  organization: {} as Organization,
  canChangeOrg: false,
  canChangeUser: false,
  devMode: false,
  eventBus: {} as EventBus,
  isAppContext: true,
  newDesign: false,
  setLoading: () => { },
  showNotifications: () => { },
  msal: {} as IMsalContext,
  theme: typeof Theme
});
